// extracted by mini-css-extract-plugin
export default {"checkboxes":"CheckboxesBlock_checkboxes__quJdI","asterix":"CheckboxesBlock_asterix__Xl2iF"};